import React, { useEffect, useMemo } from 'react'
import styles from '../vendorsListPage.module.scss'
import SelectCustom from '../../../components/atoms/select/SelectCustom'
import DateCustom from '../../../components/atoms/input/DateCustom'
import InputCustom from '../../../components/atoms/input/InputCustom'
import { useDispatch, useSelector } from 'react-redux'
import { getMyKazoos } from '../../../features/kazooEventSlice'

export default function WeddingSelect({
	setSelectedKazoo,
	selectedKazoo,
	hideDetails = false,
}) {
	const dispatch = useDispatch()
	const myKazoos = useSelector((state) => state.kazooEvent.myKazoos)

	useEffect(() => {
		dispatch(getMyKazoos())
	}, [dispatch])
	useEffect(() => {
		setSelectedKazoo((prev) => ({
			...prev,
			guestCount: parseInt(selectedKazoo?.guestCount),
		}))
	}, [selectedKazoo?.guestCount])

	const weddingOptions = useMemo(
		() =>
			myKazoos?.length
				? myKazoos.map((kazoo) => ({
						label: kazoo.kazooName,
						value: kazoo._id,
					}))
				: [],
		[myKazoos]
	)

	const handleWeddingSelect = (id) => {
		if (id) {
			const kazoo = myKazoos.find((k) => k._id === id)
			setSelectedKazoo({
				...(selectedKazoo || {}),
				...kazoo,
			})
		}
	}
	return (
		<div className={styles.VendorsListModalBody}>
			<div className="">
				<label htmlFor="Select Wedding" className={styles.label}>
					Select Wedding<span style={{ color: 'red' }}> *</span>
				</label>
				<SelectCustom
					options={weddingOptions}
					renderValueAsLabel={true}
					defaultValue={selectedKazoo?._id || ''}
					setDataFunction={({ value }) => handleWeddingSelect(value)}
				/>
			</div>
			{!hideDetails && (
				<>
					<div className="">
						<DateCustom
							isRange
							startName="startDate"
							endName="endDate"
							setDataFunction={setSelectedKazoo}
							data={selectedKazoo}
							required
						/>
					</div>
					<div className="">
						<label htmlFor="guestCount" className={styles.label}>
							Guest Count
						</label>
						<InputCustom
							placeholder="Guest count"
							value={selectedKazoo?.guestCount || ''}
							data={selectedKazoo}
							setDataFunction={setSelectedKazoo}
							type="number"
							id="guestCount"
							name="guestCount"
							inputProps={{ min: 0 }}
						/>
					</div>
				</>
			)}
		</div>
	)
}
